// extracted by mini-css-extract-plugin
export default {"editor":"learning-chunk-editor_editor__Ulc4l","formContainer":"learning-chunk-editor_formContainer__ejtGQ"};